<ng-container *transloco="let t">
    <div class="row">
      <div class="col-md-3  mb-4">
        <div class="admin-card" style="height: 200px">
          <div class="admin-card__title">Event summary</div>
        </div>
      </div>
      <div class="col-md-3  mb-4">
        <div
          class="admin-card" style="height: 200px">
          <div class="admin-card__title">Event participants summary</div>
        </div>
      </div>
      <div class="col-md-3  mb-4">
        <div
          class="admin-card" style="height: 200px"></div>
      </div>
      <div class="col-md-3  mb-4">
        <div class="admin-card" style="height: 200px"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-8  mb-4">
            <div
              class="admin-card" style="height: 200px"></div>
          </div>
          <div class="col-md-4  mb-4">
            <div
              class="admin-card" style="height: 200px"></div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-4">
        <div
          class="admin-card" style="height: 200px"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4  mb-4">
        <div
          class="admin-card" style="height: 200px"></div>
      </div>
      <div class="col-md-4  mb-4">
        <div
          class="admin-card" style="height: 200px"></div>
      </div>
      <div class="col-md-4  mb-4">
        <div
          class="admin-card" style="height: 200px"></div>
      </div>
    </div>
</ng-container>
